import type { IssuedCredentials } from '~/pages/backoffice/admin/user/credentials/issued-credentials'
import type { UserDialogs as UserDialogsState } from '~/pages/backoffice/admin/user/list/use-user-dialogs'
import UserDeleteModal from '~/pages/backoffice/admin/user/components/UserDeleteModal'
import UserImpersonateModal from '~/pages/backoffice/admin/user/components/UserImpersonateModal'
import UserImportModal from '~/pages/backoffice/admin/user/components/UserImportModal'
import UserModal from '~/pages/backoffice/admin/user/components/UserModal'
import UserSessionsModal from '~/pages/backoffice/admin/user/components/UserSessionsModal'

type IProps = {
  dialogs: UserDialogsState
  /** Une création, un import, une modification ou une suppression a abouti. */
  onChanged: () => void
  /** Identifiants d'apprenants en pseudo émis (#271), à montrer une fois. */
  onIssued: (credentials: IssuedCredentials[]) => void
}

/** Les modales ouvertes depuis la liste des comptes. */
function UserDialogs({ dialogs, onChanged, onIssued }: IProps) {
  const { open, user, close } = dialogs

  return (
    <>
      {open === 'form' && (
        <UserModal
          open
          onCancel={close}
          onSuccess={onChanged}
          onIssued={user ? undefined : issued => onIssued([issued])}
          defaultValues={user && {
            id: user.id,
            email: user.email ?? undefined,
            firstName: user.firstName,
            lastName: user.lastName,
            roleId: user.role.id,
            username: user.username,
            company: user.company,
            department: user.department,
          }}
        />
      )}

      {open === 'import' && (
        // Le panneau reste ouvert sous le dialogue : les lignes refusées y restent lisibles.
        <UserImportModal open onCancel={close} onSuccess={onChanged} onIssued={onIssued} />
      )}

      {user && (
        <>
          <UserDeleteModal open={open === 'delete'} onCancel={close} onSuccess={onChanged} user={user} />
          <UserImpersonateModal open={open === 'impersonate'} onCancel={close} user={user} />
          <UserSessionsModal open={open === 'sessions'} onCancel={close} user={user} />
        </>
      )}
    </>
  )
}

export default UserDialogs
